import { AggregateReport, DomainBreakdown } from '../services/policy-gap-analysis.service';

export const domainBreakdownMockData: DomainBreakdown[] = [
  {
    domain: 'access_control',
    display_name: 'Access Control',
    validated: 9,
    documented_not_validated: 3,
    recommended_not_documented: 2,
    not_verifiable: 1,
    potentially_verifiable: 0,
    total: 15,
  },
  {
    domain: 'identity_authentication',
    display_name: 'Identity & Authentication',
    validated: 5,
    documented_not_validated: 1,
    recommended_not_documented: 0,
    not_verifiable: 0,
    potentially_verifiable: 2,
    total: 8,
  },
  {
    domain: 'endpoint_security',
    display_name: 'Endpoint Security',
    validated: 4,
    documented_not_validated: 2,
    recommended_not_documented: 1,
    not_verifiable: 0,
    potentially_verifiable: 2,
    total: 9,
  },
  {
    domain: 'vulnerability_management',
    display_name: 'Vulnerability Management',
    validated: 5,
    documented_not_validated: 4,
    recommended_not_documented: 3,
    not_verifiable: 1,
    potentially_verifiable: 0,
    total: 13,
  },
  {
    domain: 'incident_response',
    display_name: 'Incident Response',
    validated: 4,
    documented_not_validated: 3,
    recommended_not_documented: 2,
    not_verifiable: 2,
    potentially_verifiable: 0,
    total: 11,
  },
  {
    domain: 'logging_monitoring',
    display_name: 'Logging & Monitoring',
    validated: 2,
    documented_not_validated: 2,
    recommended_not_documented: 1,
    not_verifiable: 0,
    potentially_verifiable: 1,
    total: 6,
  },
  {
    domain: 'security_awareness',
    display_name: 'Security Awareness',
    validated: 0,
    documented_not_validated: 0,
    recommended_not_documented: 1,
    not_verifiable: 1,
    potentially_verifiable: 0,
    total: 2,
  },
  {
    domain: 'backup_recovery',
    display_name: 'Backup & Recovery',
    validated: 0,
    documented_not_validated: 0,
    recommended_not_documented: 1,
    not_verifiable: 1,
    potentially_verifiable: 1,
    total: 3,
  },
];

export const aggregateReportMockData: AggregateReport = {
  report_card: {
    alignment_label: 'moderate',
    validated_count: 24,
    documented_not_validated_count: 17,
    recommended_not_documented_count: 11,
    not_verifiable_count: 6,
    potentially_verifiable_count: 6,
    total_findings: 64,
  },
  domain_breakdown: domainBreakdownMockData,
  last_analysis_date: '2025-12-18T16:45:00Z',
  total_documents: 4,
};
